import React, { Fragment, useState, useRef, useEffect } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'
import Modal from '../../common/Modal';
import Button from "../../Button";
import styles from '../Forms/StudentImport/StudentImport.module.sass'
import Select from 'react-select';
import AsyncSelect from 'react-select/async'
import School from "../../../models/School";
import axios from 'axios';

const ButtonTrigger = ({ jobs, scheduledJobs, jobYears, backgrounds }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState()
  const [school, setSchool] = useState();
  const [job, setJob] = useState();
  const [scheduledJob, setScheduledJob] = useState();
  const [clearExports, setClearExports] = useState(false);
  const [filter, setFilter] = useState(0);
  const [isTest, setIsTest] = useState(false);
  const [scheduledJobLabel, setScheduledJobLabel] = useState();
  const [year, setYear] = useState();
  const [backgroundId, setBackgroundId] = useState(null);
  const form = useRef(null)

  const formattedScheduledJobs = () => scheduledJobs.map(job => ({ label: job.label, value: job.value }))
  const selectedScheduledJob = () => scheduledJobs.find(job => job.label === scheduledJobLabel)

  const openModal = () => setIsOpen(true);
  const closeModal = () => {
    setIsOpen(false)
    setIsSubmitting(false)
    setFormData()
  };
  const { register, handleSubmit, control, setValue } = useForm();

  const onSubmit = () => {
    setIsSubmitting(true)

    const formData = new FormData(form.current)

    formData.append('school_id', school)
    formData.append('job', job)
    formData.append('scheduled_job', scheduledJob)
    formData.append('year', year)
    formData.append('clear', clearExports)
    formData.append('filter', filter)
    formData.append('test', isTest)
    if (backgroundId) {
      formData.append('background_id', backgroundId)
    }

    axios.post('/admin/generated_products/trigger.js', formData)
      .then((res) => {
        if (res.data.status === 200) {
          toast('Students are now generating in the background.',
            { type: 'success' });
          closeModal();
        } else {
          toast(res.data.errors,
            { type: 'error' });
        }
      })
  }

  const loadSchoolOptionsQuery = ({ valueField }) => (value, callback) => {
    School
      .where({
        sales_stat: { match: 'CUST' },
        name: { match: value },
      })
      .order({ name: 'asc' })
      .all()
      .then((res) => {
        const options = res.data.map((e) => ({ label: e.name, value: e.id, data: e }))
        callback(options)
      })
  }

  const loadSchoolOptions = loadSchoolOptionsQuery('name')

  const renderForm = () => {
    return (
      <form ref={form} onSubmit={handleSubmit(onSubmit)} className={styles.form}>
        School
        <AsyncSelect
          cacheOptions
          defaultOptions
          placeholder="Select the school for the student"
          name={name}
          loadOptions={loadSchoolOptions}
          onChange={(opt) => setSchool(opt.value)}
        />

        <br/>

        Job
        <Select
          placeholder="Jobs"
          options={jobs}
          width="100px"
          onChange={(e) => setJob(e.value)}
        />

        <br/>

        Scheduled Job
        <Select
          placeholder="Scheduled Job"
          options={formattedScheduledJobs()}
          width="100px"
          onChange={(e) => {
            setScheduledJob(e.value);
            setScheduledJobLabel(e.label)
          }}
        />

        <br/>

        Year the job takes place
        <Select
          placeholder="Job year"
          options={jobYears}
          width="100px"
          onChange={(e) => setYear(e.value)}
        />

        {scheduledJobLabel?.includes('Yearbook Covers') && (
          <>
            <br />
            <input
              type="checkbox"
              className={styles.checkbox}
              onChange={(e) => setClearExports(!clearExports)} />
            Clear existing exported yearbook covers and generate all

            <br/>

            <hr />
            Filter:
            <div>
              <input type="radio" value="not_printed" name="filter" onChange={() => setFilter('not_printed')} /> All orders for which cover printed boolean is not set <br/>
              <input type="radio" value="not_shipped" name="filter" onChange={() => setFilter('not_shipped')} /> All orders for which ship date is null
            </div>
          </>
        )}

        {selectedScheduledJob()?.audience === 'Parents' && (
          <>
            <br />
            <input
              type="checkbox"
              className={styles.checkbox}
              onChange={(e) => setIsTest(!isTest)} />
            Trigger as a test
          </>
        )}

        {scheduledJobLabel?.startsWith('Pic4tea') && backgrounds && (
          <>
            <br />
            Background (optional)
            <Select
              placeholder="Use school default"
              options={backgrounds}
              isClearable
              onChange={(e) => setBackgroundId(e?.value || null)}
            />
          </>
        )}

        <div className={styles.formActions}>
          <Button
            fullWidth
            variant='primary'
            disabled={!school || !job || !scheduledJob || !year}
          >
            Continue
          </Button>
        </div>
      </form>
    )
  }

  return (
    <Fragment>
      <ToastContainer
        position="bottom-left"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

      <Modal
        modalBodyProps={{ className: styles.modalBody }}
        modalIsOpen={isOpen}
        closeModal={closeModal}
        contentLabel="Trigger Scheduled Job"
        headerText="Trigger Scheduled Job"
      >
        {renderForm()}
      </Modal>

      <Button onClick={openModal} variant={'primary'} fullWidth={true}>
        Trigger Scheduled Job
      </Button>
    </Fragment>
  )
}

export default ButtonTrigger;
